import clsx from 'clsx';
import React from 'react';

import { NavOption } from '../types';

interface NavButtonProps {
  id: NavOption;
  name: string;
  isActive: boolean;
  onClick: (section: NavOption) => void;
}

export const NavButton = ({ id, name, isActive, onClick }: NavButtonProps) => (
  <button
    type="button"
    onClick={() => onClick(id)}
    className={clsx(
      '-ml-[5px] border-0 border-l-[5px] border-solid border-transparent bg-transparent pl-16',
      'text-left text-button-lg font-normal text-black hover:text-primary-magenta',
      {
        'text-primary-magenta': isActive,
      }
    )}
  >
    {name}
  </button>
);
